import React from "react";

const hurdles = [
  {
    k: "Regulatory friction",
    v: "Each jurisdiction layers tax, licensing, and tenancy law — most landlords learn the cost of error too late.",
  },
  {
    k: "Vendor opacity",
    v: "Local contractors, agents, and managers operate behind language and incentive gaps that erode yield silently.",
  },
  {
    k: "Distance",
    v: "Time-zone lag turns small property issues into expensive ones. Boots-on-the-ground decisions cannot wait.",
  },
  {
    k: "Misaligned advisors",
    v: "Brokerage commissions and management fees are rarely structured to align with your long-term return.",
  },
];

export default function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="py-24 md:py-32 bg-[#F9F8F6] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.28em] text-[#6E5A4E]">The Challenge</span>
            <h2 className="font-serif-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#2B211A] leading-[1.05]">
              Owning property abroad
              <span className="italic text-[#8C735D]"> rarely</span> feels passive.
            </h2>
            <p className="mt-7 text-[#6E5A4E] text-lg leading-relaxed max-w-md">
              The friction between an investor and a Tier-1 asset is structural, not accidental.
              Dira Yanuar Rusdias LLC was built to translate that friction into a clean, accountable engagement.
            </p>
          </div>

          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-[#D6CDBB]">
            <ul className="divide-y divide-[#D6CDBB]">
              {hurdles.map((h, i) => (
                <li key={h.k} data-testid={`problem-item-${i}`} className="py-7 grid grid-cols-[auto_1fr] gap-6 items-start">
                  <span className="font-serif-display text-3xl text-[#B89A7E] leading-none w-12">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-serif-display text-2xl text-[#2B211A]">{h.k}</h3>
                    <p className="mt-2 text-[#6E5A4E] leading-relaxed">{h.v}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
